var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaleorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "journal-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.552,
    height: 21.922,
    viewBox: "0 0 20.552 21.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M12.836,6.2a.685.685,0,0,1,0,.97l-4.11,4.11a.685.685,0,0,1-.97,0L5.7,9.226a.686.686,0,0,1,.97-.97L8.24,9.827,11.866,6.2a.685.685,0,0,1,.97,0Z",
    transform: "translate(2.035 2.22)",
    fill: "#003082",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M3.74,0h13.7a2.74,2.74,0,0,1,2.74,2.74V19.182a2.74,2.74,0,0,1-2.74,2.74H3.74A2.74,2.74,0,0,1,1,19.182v-1.37H2.37v1.37a1.37,1.37,0,0,0,1.37,1.37h13.7a1.37,1.37,0,0,0,1.37-1.37V2.74a1.37,1.37,0,0,0-1.37-1.37H3.74A1.37,1.37,0,0,0,2.37,2.74V4.11H1V2.74A2.74,2.74,0,0,1,3.74,0Z",
    transform: "translate(0.37)",
    fill: "#003082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M1.37,5.37V4.685a.685.685,0,0,1,1.37,0V5.37h.685a.685.685,0,0,1,0,1.37H.685a.685.685,0,0,1,0-1.37Zm0,8.221v-.685a.685.685,0,1,1,1.37,0v.685h.685a.685.685,0,1,1,0,1.37H.685a.685.685,0,1,1,0-1.37Z",
    transform: "translate(0 1.48)",
    fill: "#003082"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2306",
    "data-name": "Trazado 2306",
    d: "M1.342,19.7v-.671a.671.671,0,1,1,1.342,0V19.7h.671a.671.671,0,1,1,0,1.342H.671a.671.671,0,0,1,0-1.342Z",
    transform: "translate(0.043 -8.738)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleorder);
export default __webpack_public_path__ + "static/media/saleorder.e47f2b7fe0431c02505ae839d3cd1b58.svg";
export { ForwardRef as ReactComponent };